import { ThemeModeSwitcher } from "@/components/ThemeModeSwitcher"

export function SetupPage() {
  return (
    <div className="relative flex min-h-svh w-full min-w-0 flex-col bg-background px-4 py-12 pt-16 sm:px-8 sm:pt-20 lg:px-12">
      <div className="absolute right-4 top-4 z-20 sm:right-6 sm:top-6">
        <ThemeModeSwitcher variant="floating" />
      </div>
      <div
        className="pointer-events-none fixed inset-0 z-0 h-[100dvh] w-screen max-w-[100vw] overflow-hidden"
        aria-hidden
      >
        <div className="absolute -left-[10%] top-1/4 size-[min(36rem,85vw)] rounded-full bg-primary/[0.06] blur-3xl" />
        <div className="absolute -right-[8%] bottom-[10%] size-[min(40rem,90vw)] rounded-full bg-primary/[0.05] blur-3xl" />
      </div>
      <div className="relative z-10 w-full min-w-0 max-w-none space-y-6 pt-4 sm:pt-8">
        <div className="space-y-2">
          <p className="font-mono text-xs tracking-widest text-primary uppercase">
            Primeiro acesso
          </p>
          <h1 className="text-2xl font-semibold tracking-tight">
            Configure o acesso local
          </h1>
          <p className="text-sm text-muted-foreground">
            Nenhum usuário foi criado ainda. Execute o comando abaixo no
            terminal para criar o primeiro administrador.
          </p>
        </div>
        <div className="rounded-md border bg-muted/40 p-4">
          <code className="font-mono text-sm text-primary">
            bun run users add administrador admin SuaSenhaAqui
          </code>
        </div>
        <p className="text-xs text-muted-foreground">
          Após criar o usuário, recarregue esta página.
        </p>
      </div>
    </div>
  )
}
